import useClientState from '@/state/useClientState';

const useMaterieelTypen = () => useClientState((state) => state.materieelTypen);
export default useMaterieelTypen;
